import React from 'react';
import { injectIntl } from 'react-intl';
import { Responsive, Icon, Dropdown } from 'semantic-ui-react';
import { breakpoints } from 'helpers/breakpoints';
import { addons } from './locale';
import style from './index-module.css';
import './index.css';
import { Input } from '../../inputs';
import Button from '../../button';

const PLACEHOLDER_TAX_RATE_ID = 'placeholder_tax_rate';
const CUSTOM_TAX_SELECTION_ID = 'new_custom_tax';
const MAX_TAX_NAME_CHARACTER = 255;

const fields = {
  taxNameInput: {
    id: 'taxNameInput',
    type: 'text',
    required: true
  },
  taxPercentInput: {
    id: 'taxPercentInput',
    type: 'number',
    required: true
  },
  taxRegNumInput: {
    id: 'taxRegNumInput',
    type: 'text',
    required: false
  }
};

const TaxForm = injectIntl((props) => {
  const formatTaxLabel = (tax) => {
    return (
      <div>
        <b>{tax.name}</b> - {tax.percent}% {tax.taxId ? `- Tax #${tax.taxId}` : ''}
      </div>
    );
  }

  const formatTaxValue = (tax) => {
    return `${tax.name} - ${tax.percent}% ${tax.taxId ? `- Tax #${tax.taxId}` : ''}`;
  }

  const renderCustomTaxForm = (index) => {
    const { intl } = props;
    const tax = props.taxes[index];
    const saveable = tax.unformattedName
      && tax.unformattedName.length > 0
      && tax.unformattedName.length <= MAX_TAX_NAME_CHARACTER
      && tax.percent > 0 
      && tax.percent <= 100;
    const enabledClass = saveable ? style.enabledClass : '';
    const taxNameInputClasses =
      `${style.addOnInputs} ${tax.unformattedName?.length > MAX_TAX_NAME_CHARACTER ? style.error : ''}`;
    const percentInputClasses = `${style.addOnInputs} ${tax.percent > 100 ? style.error : ''}`;

    return (
      <div key={index}>
        <div>
          <div>
            <Responsive 
              minWidth={breakpoints.tablet}
              className={`${style.addOnTaxWrapper} ${style.gridWrapper}`}
            >
              <Input
                id={fields.taxNameInput.id}
                onChange={e => {
                  props.updateTaxInput(index, 'unformattedName', e.target.value);
                }}
                type={fields.taxNameInput.type}
                placeholder={intl.formatMessage(addons.taxNameInputPlaceholder)}
                className={taxNameInputClasses}
                required={fields.taxNameInput.required}
              >
                {intl.formatMessage(addons.taxNameInput)}
              </Input>
              <Input
                id={fields.taxRegNumInput.id}
                onChange={e => {
                  props.updateTaxInput(index, 'taxId', e.target.value);
                }}
                type={fields.taxRegNumInput.type}
                className={style.addOnInputs}
                required={fields.taxRegNumInput.required}
              >
                {intl.formatMessage(addons.taxRegNumInput)}
              </Input>
              <div className={style.taxPercentInput}>
                <Input
                  id={fields.taxPercentInput.id}
                  onChange={e => {
                    props.updateTaxInput(index, 'percent', e.target.value);
                  }}
                  type={fields.taxPercentInput.type}
                  className={percentInputClasses}
                  required={fields.taxPercentInput.required}
                  isPercentage
                >
                  {intl.formatMessage(addons.taxPercentInput)}
                </Input>
              </div>
            </Responsive>
            <Responsive
              maxWidth={breakpoints.largestMobile}
              className={`${style.addOnTaxWrapper} ${style.gridWrapper} ${style.addOnMobileTaxWrapper}`}
            >
              <div className={style.addOnTaxWrapperRow}>
                <Input
                  id={fields.taxNameInput.id}
                  onChange={e => {
                    props.updateTaxInput(index, 'unformattedName', e.target.value);
                  }}
                  type={fields.taxNameInput.type}
                  placeholder={intl.formatMessage(addons.taxNameInputPlaceholder)}
                  className={taxNameInputClasses}
                  required={fields.taxNameInput.required}
                >
                  {intl.formatMessage(addons.taxNameInput)}
                </Input>
                <div className={style.taxPercentInput}>
                  <Input
                    id={fields.taxPercentInput.id}
                    onChange={e => {
                      props.updateTaxInput(index, 'percent', e.target.value);
                    }}
                    type={fields.taxPercentInput.type}
                    className={percentInputClasses}
                    required={fields.taxPercentInput.required}
                    isPercentage
                  >
                    {intl.formatMessage(addons.taxPercentInput)}
                  </Input>
                </div>
              </div>
              <Input
                id={fields.taxRegNumInput.id}
                onChange={e => {
                  props.updateTaxInput(index, 'taxId', e.target.value);
                }}
                type={fields.taxRegNumInput.type}
                className={style.addOnInputs}
                required={fields.taxRegNumInput.required}
              >
                {intl.formatMessage(addons.taxRegNumInput)}
              </Input>
            </Responsive>
          </div>
          <div className={style.createNewTax}>
            <div
              role="button"
              tabIndex={index}
              onClick={() => props.handleRemoveTax(index)}
              className={style.cancelNewTax}
            >
              {intl.formatMessage(addons.cancelTax)}
            </div>
            <div
              className={`${style.customTaxSave} ${enabledClass}`}
              onClick={() => {
                if (!props.savingList[index] && saveable) {
                  props.handleSave(index);
                }
              }}
              role="button"
              tabIndex={0}
            >
              {!props.savingList[index] 
                ? intl.formatMessage(addons.saveTax)
                : intl.formatMessage(addons.savingTax)
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  const onTaxSelected = (index, selectedOption) => {
    if (selectedOption.id === CUSTOM_TAX_SELECTION_ID) {
      props.handleCustomTaxSelection(index);
      return;
    }
    props.handleSelectTax(index, selectedOption.id);
  }

  const taxSelector = (index, selected) => {
    let selectedTax = selected ? props.taxes[index] : null;
    let taxesList = props.availableTaxesList();
    if (selected) {
      taxesList = [selectedTax, ...taxesList];
      selectedTax = Object.assign({}, selectedTax, {
        label: formatTaxLabel(selectedTax),
        value: formatTaxValue(selectedTax)
      });
    }
    taxesList = taxesList.map((tax) => {
      let { label, value } = tax;
      if (!label) {
        label = formatTaxLabel(tax);
        value = formatTaxValue(tax);
      }
      return Object.assign({}, tax, {
        label,
        value
      });
    });
    const taxFormSelectorClasses = `TaxForm__taxSelector ${selectedTax ? 'taxSelected' : ''}`;
    const getTaxFormMenuClasses = (id) => `${selectedTax?.id === id ? 'selectedOption' : ''}`;

    return <Dropdown
        selection
        text={selectedTax?.label}
        placeholder={props.intl.formatMessage(addons.selectTax)}
        className={taxFormSelectorClasses}
      >
        <Dropdown.Menu>
          {taxesList
            .map((tax) => (
              <Dropdown.Item
                key={tax.label}
                text={tax?.label}
                onClick={_ => {
                  onTaxSelected(index, tax)
                }}
                className={getTaxFormMenuClasses(tax.id)}
              />
          ))}
        </Dropdown.Menu>
      </Dropdown>
  }

  const addTaxesButtonClass = 
    `white ${style.addNewTaxBtn} ${props.taxes.length && style.addNewTaxBtnExpand} ui fluid inverted primary button`;

  return <>
    <div className={style.taxFormContainer}>
      {
        props.taxes.map((tax, index) => (
          <div>
            {tax.id === PLACEHOLDER_TAX_RATE_ID && renderCustomTaxForm(index)}
            {tax.id !== PLACEHOLDER_TAX_RATE_ID &&
              <div className={style.taxDropdownContainer}>
                <div className={style.taxDropdown}>
                  {taxSelector(index, props.selectedTaxes[index])}
                  <div className={style.trashDeleteIcon}>
                    <button className="ui fluid icon button" onClick={() => props.handleRemoveTax(index)}>
                      <i aria-hidden="true" className="grey large icon universe-delete"/>
                    </button>
                  </div>
                </div>
              </div>
            }
            <div className={style.line} />
          </div>
        ))
      }
      <Button
        className={addTaxesButtonClass}
        onClick={() => { props.handleAddTax(); }}
      >
        <Icon className="universe-plus" />
        {
          props.availableTaxesList().length === 1
          ? props.intl.formatMessage(addons.addNewTax)
          : props.intl.formatMessage(addons.addTax)
        }
      </Button>
    </div>
  </>
}); 

export default TaxForm;
